/* DIY Printz Studio product template: gallery, sticky buy bar, prompt filters. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function gallery(root) {
    root.querySelectorAll('[data-dpp-gallery]').forEach(function (g) {
      if (g.__dpp) return; g.__dpp = 1;
      var stage = g.querySelector('.dpp__stage');
      var slides = stage ? stage.querySelectorAll('.dpp__slide') : [];
      var thumbs = g.querySelectorAll('[data-dpp-thumb]');
      var cur = g.querySelector('[data-dpp-cur]');
      if (!stage || slides.length < 2) return;
      var idx = 0;
      function go(i) {
        i = (i + slides.length) % slides.length;
        stage.scrollTo({ left: stage.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
      }
      function mark(i) {
        idx = i;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        if (cur) cur.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      }
      var tick;
      stage.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () { mark(Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth))); }, 60);
      }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-dpp-thumb'), 10)); }); });
      var p = g.querySelector('[data-dpp-prev]'), n = g.querySelector('[data-dpp-next]');
      if (p) p.addEventListener('click', function () { go(idx - 1); });
      if (n) n.addEventListener('click', function () { go(idx + 1); });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      });
      window.addEventListener('resize', function () { stage.scrollLeft = stage.clientWidth * idx; });
    });
  }

  function buyBar(root) {
    var bar = document.querySelector('[data-dpp-bar]');
    var form = document.querySelector('[data-dpp-form]');
    if (!bar || bar.__dpp) return; bar.__dpp = 1;
    if (!form || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('button');
    var footer = document.querySelector('footer, .shopify-section-group-footer-group');
    var formVisible = true, footerVisible = false;
    function upd() {
      var on = !formVisible && !footerVisible;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }
    new IntersectionObserver(function (e) { formVisible = e[0].isIntersecting || e[0].boundingClientRect.top > window.innerHeight; upd(); }).observe(form);
    if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; upd(); }).observe(footer);
  }

  function busy(root) {
    root.querySelectorAll('[data-dpp-form]').forEach(function (f) {
      if (f.__dpp) return; f.__dpp = 1;
      f.addEventListener('submit', function () { var b = f.querySelector('.dpp__add'); if (b) b.classList.add('is-busy'); });
    });
    window.addEventListener('pageshow', function () { document.querySelectorAll('.dpp__add.is-busy').forEach(function (b) { b.classList.remove('is-busy'); }); });
  }

  function prompts(root) {
    root.querySelectorAll('[data-dpr]').forEach(function (lib) {
      if (lib.__dpp) return; lib.__dpp = 1;
      var cards = Array.prototype.slice.call(lib.querySelectorAll('.dpr__card'));
      var limit = parseInt(lib.getAttribute('data-limit') || '9', 10);
      var moreWrap = lib.querySelector('.dpr__more');
      var moreBtn = lib.querySelector('[data-dpr-more]');
      var filter = 'all', expanded = false;
      function render() {
        var shown = 0, matches = 0;
        cards.forEach(function (c) {
          var ok = filter === 'all' || c.getAttribute('data-cat') === filter;
          if (ok) matches++;
          var show = ok && (expanded || filter !== 'all' || shown < limit);
          c.hidden = !show; if (show) shown++;
        });
        if (moreWrap) moreWrap.hidden = expanded || filter !== 'all' || matches <= limit;
      }
      lib.querySelectorAll('[data-dpr-filter]').forEach(function (b) {
        b.addEventListener('click', function () {
          filter = b.getAttribute('data-dpr-filter');
          lib.querySelectorAll('[data-dpr-filter]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          render();
        });
      });
      if (moreBtn) moreBtn.addEventListener('click', function () { expanded = true; render(); });
      render();
    });
  }

  function init(root) { root = root || document; gallery(root); buyBar(root); busy(root); prompts(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); var b = document.querySelector('[data-dpp-bar]'); if (b) b.__dpp = 0; buyBar(document); });
  document.addEventListener('shopify:block:select', function (e) { var c = e.target.closest && e.target.closest('.dpr__card'); if (c) c.hidden = false; });
})();
